const COOKIE_NAME = 'ship_to_state';
const LEGACY_COOKIE_NAME = 'shipToState';

const STATES = [
  {
    name: 'Alaska',
    abbreviation: 'AK',
  },
  {
    name: 'Alabama',
    abbreviation: 'AL',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
  },
  {
    name: 'California',
    abbreviation: 'CA',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
  },
];

class StateSelector extends HTMLElement {
  static initialized = false;
  static state = undefined;
  static customerId = undefined;
  static storeId = undefined;
  static stateSelectors = [];

  constructor() {
    super();
    StateSelector.stateSelectors.push(this);
    StateSelector.init();
  }

  static async init() {
    if (!StateSelector.initialized) {
      StateSelector.initialized = true;
      // first check for the new cookie
      const value = StateSelector.getCookie(COOKIE_NAME);
      if (value) {
        return StateSelector.setState(value);
      }

      // if not found, check for the legacy cookie
      if (!value) {
        const legacyCookieValue = StateSelector.getLegacyStateCookie();
        if (legacyCookieValue) {
          return StateSelector.setState(legacyCookieValue);
        } else {
          // Check if we have a customer state from the DOM before falling back to GeoIP
          const customerState = this.getCustomerStateFromDOM();
          if (customerState) {
            return StateSelector.setState(customerState);
          } else {
            await this.geoIpLookup();
          }
        }
      }
    }
  }

  static setState(value) {
    // find the state from the dictionary
    const state = STATES.find((state) => {
      return state.name === value || state.abbreviation === value;
    });

    // only update the state if the value is different
    if (state && JSON.stringify(StateSelector.state) !== JSON.stringify(state)) {
      StateSelector.state = state;
      StateSelector.setCookie(COOKIE_NAME, state.abbreviation);

      // Use CartUtils for consistent cart operations with subscription removal
      if (window.CartUtils) {
        window.CartUtils.updateCart(
          {},
          {
            attributes: {
              state: state.abbreviation,
            },
          }
        );
      } else {
        // Fallback to direct fetch if CartUtils is not available
        fetch('/cart/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              state: state.abbreviation,
            },
          }),
        });
      }

      document.dispatchEvent(new CustomEvent('STATE_CHANGE', { detail: { state } }));
    }
  }

  static getLegacyStateCookie() {
    const cookie = StateSelector.getCookie(LEGACY_COOKIE_NAME);
    if (cookie) {
      try {
        const decoded = decodeURIComponent(cookie);
        const parsed = JSON.parse(decoded);
        if (parsed && parsed.abbr) {
          return parsed.abbr;
        }
      } catch (e) {
        return null;
      }
    }
  }

  static getCustomerStateFromDOM() {
    // Look for the state-selector element and get the customer state from its attributes
    const stateSelector = document.querySelector('header-state-selector');
    if (stateSelector) {
      const customerState = stateSelector.getAttribute('state');
      if (customerState && customerState.trim() !== '') {
        return customerState;
      }
    }
    return null;
  }

  static isBotOrSpider() {
    const botPattern =
      /bot|crawler|spider|crawling|slurp|facebookexternalhit|twitterbot|linkedinbot|whatsapp|applebot|duckduckbot|baiduspider|yandexbot|sogou|exabot|ia_archiver|semrushbot|ahrefsbot|mj12bot|dotbot/i;
    return botPattern.test(navigator.userAgent);
  }

  static async geoIpLookup() {
    // Skip GeoIP entirely for bots and crawlers — they don't need state detection
    // and the extra requests add noise to analytics and waste API quota.
    if (StateSelector.isBotOrSpider()) return;

    // Try primary GeoIP service, fallback to a reliable public alternative
    const geoipDomain = window.FL_SERVICES_DOMAIN || 'firstleaf.com';
    const services = [
      () =>
        fetch(`https://geoip.${geoipDomain}/lookup`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            myshopifyId: StateSelector.storeId,
            customerId: StateSelector.customerId,
          }),
        }),
      () => fetch('https://ipapi.co/json/'),
    ];

    for (const service of services) {
      try {
        const response = await service();
        // Treat any non-2xx status (403, 429, 5xx, …) as a failure so we
        // fall through to the next service rather than silently parsing an
        // error body that has no location data.
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        const state = data.state || data.region_code;
        const country = data.country || data.country_code;

        // We received a valid location response for a non-US visitor.
        // No state can be set, and there is no point trying the fallback
        // service — we already know where the user is.
        if (country && country !== 'US') return;

        if (country === 'US' && state) {
          StateSelector.setState(state);
          return;
        }
        // country is unknown in this response — try the next service
      } catch (error) {
        continue; // service failed (network error, non-2xx, bad JSON) — try next
      }
    }

    console.log('GeoIP lookup failed - user will select state manually');
  }

  static setCookie(name, value) {
    document.cookie = `${name}=${value}; path=/; max-age=31536000`; // 1-year expiration
  }

  static getCookie(name) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
  }
}
